(function() {
'use strict';

angular.module('ekh').controller('EmiratesSingleOffers', EmiratesSingleOffers);

function EmiratesSingleOffers(destinationService, cmsPageMapping, $routeParams, $anchorScroll, $window, broker, resourceService, $scope) {
    $anchorScroll(0, 0);

    const cm = this;

    broker.subscribe('EmiratesSingleOffers', 'hotelDetailCallFailed', function() {
        $scope.$emit('flash:error', resourceService.get('HOTELDETAILERROR'));
    });

    if (!TRPCONFIG.Domain.OverrideHotelInformationFromCms) {
        cm.controls = {};
        cm.cmsItemsFound = true;

        cmsPageMapping.getSingleOffers().then(types => {
            const type = _.filter(types, type => {
                if ($routeParams.estabId != null) {
                    return type.estabid === $routeParams.estabId;
                }
                return type.linkurl ? type.linkurl.indexOf($window.location.pathname) > -1 : false;
            })[0];

            if (type) {
                cm.controls.name = type.name;
                destinationService.getTiles({ ControlId: type.controlid }).then(components => {
                    const componentsByType = (_.groupBy(components, 'controltype'));
                    _.forEach(componentsByType, component => {
                        component.forEach(c => {
                            destinationService.getTiles({ ControlId: c.controlid }).then(tiles => {
                                cm.controls[c.controltype] = tiles;
                            });
                        });
                    });
                });
            } else {
                cm.cmsItemsFound = false;
            }
        });
    }
}
})();
